import React from 'react';
import Error from './Error';
import BaseInput, { InputWrap } from './BaseInput';
import Label from './Label';
import FormElement from './FormElement';

export default function StyledInputCurrency(props) {
	return (
		<FormElement>
			<Label>{props.label}</Label>
			<InputWrap>
				<BaseInput
					name={props.name}
					type={props.type}
					onChange={props.onChange}
					onBlur={props.onBlur}
					value={props.value}
					{...props.passedProps}
				/>
				{props.children}
			</InputWrap>
			<Error>{props.error}</Error>
		</FormElement>
	);
}
